import React, { useCallback } from 'react';
import { Stack, Button } from '@mui/material';
import { Link as RLink, useNavigate } from 'react-router-dom';
import { styled } from '@mui/system';
import { useTranslation } from 'react-i18next';
import { useLanguage } from '../../../hooks/useLanguage';
// import { useLanguage } from '../hooks/useLanguage';

const Link = styled(RLink)`
  text-decoration: none;
  color: #000;
  font-size: 20px;
  font-family: 'Inter';
`;

const LandingHeader: React.FC = () => {
  const navigate = useNavigate();

  // 言語切り替え
  const { t } = useTranslation();
  const [lang, handleLangChange] = useLanguage();

  const toLogin = useCallback(() => {
    navigate('/login');
  }, [navigate]);

  return (
    <Stack direction="row" alignItems="center" spacing={4}>
      <Link to="https://www.gaia-vision.co.jp/" target="_blank">
        {t('header.landing.company')}
      </Link>

      <Button variant="text" onClick={handleLangChange}>
        {lang === 'ja' ? 'English' : 'Japanese'}
      </Button>
      <Link to={'/contact'}>{t('header.landing.info')}</Link>
      {/* <Button style={{ border: '1px solid #137A48', color: '#137A48', width: 150, height: 50, fontSize: 20, fontFamily: 'Inter' }} onClick={toLogin}>
        新規申込
      </Button> */}
      <Button
        style={{
          marginLeft: '16px',
          backgroundColor: '#137A48',
          color: '#fff',
          width: 150,
          height: 50,
          fontSize: 20,
          fontFamily: 'Inter',
        }}
        onClick={toLogin}
      >
        {t('header.menu.login')}
      </Button>
    </Stack>
  );
};

export default LandingHeader;
